import { render } from "./DisclosuresForm.vue?vue&type=template&id=4cd06f1c"
import script from "./DisclosuresForm.vue?vue&type=script&lang=js"
export * from "./DisclosuresForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__